import { render } from "./PrefComp.vue?vue&type=template&id=405055ce&scoped=true"
import script from "./PrefComp.vue?vue&type=script&lang=js"
export * from "./PrefComp.vue?vue&type=script&lang=js"

import "./PrefComp.vue?vue&type=style&index=0&id=405055ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405055ce"]])

export default __exports__